module.exports = __webpack_public_path__ + "img/Social Networker.f0bdb4e4.svg";